// ease-in smooth animation
const outQuad = (n) => n * (2 - n);

export function scrollToContent(element) {
  let start = null;
  const elementPosition = element ? element.getBoundingClientRect().top : 0;
  const initialScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
  let targetPosition = 0;
  let animationProgress;

  function showAnimation(timestamp) {
    if (!start) {
      start = timestamp || new Date().getTime();
    } // get timestamp of animation required for requestAnimationFrame

    const elapsed = timestamp - start;
    animationProgress = elapsed / 300; // animation duration 300ms

    const easeInPercentage = +outQuad(animationProgress).toFixed(2);

    const scrollUp = initialScrollPosition - initialScrollPosition * easeInPercentage;
    const scrollDown = initialScrollPosition + elementPosition * easeInPercentage;

    targetPosition = elementPosition === 0 ? scrollUp : scrollDown;

    window.scrollTo(0, targetPosition);

    const alreadyVisible =
      elementPosition > 0
        ? targetPosition >= initialScrollPosition + elementPosition
        : targetPosition <= initialScrollPosition + elementPosition;

    const alreadyAtTheTop = elementPosition === 0 && targetPosition <= 0;

    if (alreadyVisible || alreadyAtTheTop) {
      cancelAnimationFrame(start);
      targetPosition = 0;
    } else {
      window.requestAnimationFrame(showAnimation);
    }
  }
  window.requestAnimationFrame(showAnimation);
}
